module.exports = __webpack_public_path__ + "static/media/Thought-leaders-rice-field.c03eaae8.jpg";